import dayjs, {
  Dayjs,
} from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

let defaultTimeZoneId: string = 'America/New_York';

export function setDefaultTimeZoneId(timeZoneId?: string | null) {
  defaultTimeZoneId = timeZoneId ?? 'America/New_York';
  dayjs.tz.setDefault(defaultTimeZoneId);
}

export function getDefaultTimeZoneId() {
  return defaultTimeZoneId;
}

export function getOrgNow(): Dayjs {
  return dayjs().tz();
}

export default dayjs;
export { Dayjs };
